import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const PlaceHolder = styled(Box)(
  ({ theme }) => `
  background-color: ${theme.palette.primary.main};
  height: 2px;
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  transform: translateY(-50%);
  `,
);

export const Container = styled(Box)`
  ul {
    list-style: none;
    padding-left: 0;
    padding-right: 0;
  }
  li ul li {
    padding-bottom: 5px;
    padding-left: 40px;
    padding-top: 5px;
    padding-right: 0px;
    margin-top: -10px;
  }
  li {
    list-style: none;
    transition: background-color 0.5s ease;
  }
  .placeholder-container {
    position: relative;
  }
  .dragging-source {
    opacity: 0.3;
  }

  li.drop-target {
    background-color: rgba(1, 104, 155, 0.08);
  }
`;
